import { combineReducers } from 'redux'
import activity from './activity'
import alert from './alert'
import alertGroup from './alertGroup'
import alertLevel from './alertLevel'
import alertTopic from './alertTopic'
import appUser from './appUser'
import appVersion from './appVersion'
import boVersion from './boVersion'
import cardMarketPlace from './cardMarketPlace'
import cixiReferent from './cixiReferent'
import company from './company'
import companyCategory from './companyCategory'
import companyPerLink from './companyPerLink'
import companyRole from './companyRole'
import conditionalFeature from './conditionalFeature'
import configPerTemplate from './configPerTemplate'
import configurationPersComn from './configurationPersComn'
import country from './country'
import currency from './currency'
import dashboard from './dashboard'
import dataMapping from './dataMapping'
import dateTimeFormat from './dateTimeFormat'
import electronicKey from './electronicKey'
import electronicKeyModel from './electronicKeyModel'
import excludedDomain from './excludedDomain'
import faq from './faq'
import firmwareCategory from './firmwareCategory'
import firmwareVersionPers from './firmwareVersionPers'
import groupAlertField from './groupAlertField'
import helpDesk from './helpDesk'
import keySetting from './keySetting'
import keyUsageSystemLog from './keyUsageSystemLog'
import kitConfigurationVersionPers from './kitConfigurationVersionPers'
import kitUpdatePers from './kitUpdatePers'
import label from './label'
import language from './language'
import logMail from './logMail'
import logRoutine from './logRoutine'
import logSwitchTo from './logSwitchTo'
import mailTemplate from './mailTemplate'
import message from './message'
import messageAfterConnection from './messageAfterConnection'
import modelPer from './modelPer'
import mostFrequentQuestion from './mostFrequentQuestion'
import notificationRequest from './notificationRequest'
import notificationTemplate from './notificationTemplate'
import odooSynchronization from './odooSynchronization'
import partnerAPIKey from './partnerAPIKey'
import per from './per'
import persIOTMessage from './persIOTMessage'
import persPackage from './persPackage'
import platformPageTech from './platformPageTech'
import platformTech from './platformTech'
import portal from './portal'
import portalUser from './portalUser'
import rider from './rider'
import role from './role'
import rolesConfiguration from './rolesConfiguration'
import scwPatent from './scwPatent'
import section from './section'
import serviceCenterAdmin from './serviceCenterAdmin'
import sharing from './sharing'
import showcaseAnonymizeVisitor from './showcaseAnonymizeVisitor'
import showcaseContactLog from './showcaseContactLogs'
import showcasePrivacyPolicy from './showcasePrivacyPolicy'
import showcaseStory from './showcaseStory'
import subscription from './subscription'
import systemConfig from './systemConfig'
import timezone from './timezone'
import usageSystemLog from './usageSystemLog'
import user from './user'
import vehicle from './vehicle'
import vehicleBrand from './vehicleBrand'
import vehicleModel from './vehicleModel'
import vehicleType from './vehicleType'

export default combineReducers({
  conditionalFeature,
  user,
  language,
  country,
  label,
  appUser,
  vehicle,
  timezone,
  systemConfig,
  dateTimeFormat,
  logMail,
  logRoutine,
  logSwitchTo,
  role,
  modelPer,
  cixiReferent,
  vehicleModel,
  message,
  electronicKeyModel,
  company,
  electronicKey,
  rolesConfiguration,
  subscription,
  section,
  mailTemplate,
  showcaseStory,
  vehicleBrand,
  showcasePrivacyPolicy,
  showcaseContactLog,
  platformTech,
  portal,
  appVersion,
  boVersion,
  messageAfterConnection,
  faq,
  currency,
  showcaseAnonymizeVisitor,
  sharing,
  partnerAPIKey,
  per,
  platformPageTech,
  notificationTemplate,
  notificationRequest,
  keyUsageSystemLog,
  usageSystemLog,
  alert,
  persPackage,
  companyCategory,
  companyRole,
  serviceCenterAdmin,
  companyPerLink,
  vehicleType,
  alertGroup,
  alertLevel,
  alertTopic,
  dataMapping,
  odooSynchronization,
  activity,
  groupAlertField,
  firmwareCategory,
  firmwareVersionPers,
  kitConfigurationVersionPers,
  kitUpdatePers,
  dashboard,
  rider,
  portalUser,
  persIOTMessage,
  configPerTemplate,
  configurationPersComn,
  cardMarketPlace,
  excludedDomain,
  mostFrequentQuestion,
  scwPatent,
  helpDesk,
  keySetting
})
